import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import BookkeepingCloseMonth from "@/store/modules/bookkeeping/bookkeepingCloseMonth";
import BookkeepingOptima from "@/store/modules/bookkeeping/bookkeepingOptima";
import BookkeepingSymphony from "@/store/modules/bookkeeping/bookkeepingSymphony";
import BookkeepingJPK from "@/store/modules/bookkeeping/bookkeepingJPK";

const BookkeepingModule = defineModule({
  modules: {
    closeMonth: BookkeepingCloseMonth,
    optima: BookkeepingOptima,
    symphony: BookkeepingSymphony,
    jpk: BookkeepingJPK,
  },
  namespaced: true as const,
});

export default BookkeepingModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, BookkeepingModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, BookkeepingModule);
